import React   from "react";
import SvgIcon from "material-ui/SvgIcon";

export default class MobileTearSheet extends React.Component {
    static propTypes = {
        height: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.state = {
            height: props.height || 500
        };
    }

    render() {
        let styles = {
            root: {
                margin: "2em auto",
                width: "100%",
                maxWidth: 360
            },

            container: {
                border: "solid 1px #d9d9d9",
                borderBottom: "none",
                height: this.props.height,
                overflow: "hidden"
            },

            bottomTear: {
                display: "block",
                position: "relative",
                marginTop: -7,
                width: 362
            },

            path: {
                strokeWidth: 1
            }
        };

        return (
            <div style={styles.root}>
                <div style={styles.container}>
                    {this.props.children}
                </div>

                <SvgIcon viewBox={"0 0 362 10"} style={styles.bottomTear}>
                    <path style={styles.path} fill="white" stroke="rgb(217, 217, 217)" d="M 359,0 L 359,0 359,7.5 352.5,0.5 345,8.5 337.5,0.5 330,8.5 322.5,0.5 315,8.5 307.5,0.5 300,8.5 292.5,0.5
                        285,8.5 277.5,0.5 270,8.5 262.5,0.5 255,8.5 247.5,0.5 240,8.5 232.5,0.5 225,8.5 217.5,0.5 210,8.5 202.5,0.5 195,8.5 187.5,0.5
                        180,8.5 172.5,0.5 165,8.5 157.5,0.5 150,8.5 142.5,0.5 135,8.5 127.5,0.5 120,8.5 112.5,0.5 105,8.5 97.5,0.5 90,8.5 82.5,0.5
                        75,8.5 67.5,0.5 60,8.5 52.5,0.5 45,8.5 37.5,0.5 30,8.5 22.5,0.5 15,8.5 7.5,0.5 1,7.5 1,0 0,0 "/>
                </SvgIcon>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/MobileTearSheet.js
 **/